import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

import About from "../../resources/img/about.jpg";

const AboutUs = () => {
  return (
    <Container fluid className="about-us p-0 site-content">
      <Row className="banner justify-content-center align-items-center">
        <Col lg={8} className="text-center">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="fw-bold mb-1 title text-white"
          >
            About Us
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="fs-5 text-white"
          >
            Crafting Excellence Since 1962
          </motion.p>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col lg={10}>
          <Row className="align-items-center justify-content-center">
            <Col md={6} xl={5} className="text-center">
              <motion.img
                src={About}
                alt="Sheenlac"
                className="img-fluid rounded-4"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.5 }}
              />
            </Col>
            <Col md={6} xl={5} className="mt-4 mt-md-0">
              <motion.h2
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.7 }}
                className="mb-3 fw-bold fs-2 title"
              >
                60+ Years of Excellence <br /> in Paints & Coatings
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.9 }}
                className="text-dark-emphasis"
              >
                Brand Sheenlac was envisioned and established in 1962 by our
                founder Mr. John Peter, with the ultimate goal to exceed beyond
                customer expectations through innovative products of high
                quality. Assisting him in his enterprising endeavor to make
                Sheenlac one of the finest Paint companies was our Director of
                Factories Mr. Paul Peter.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 1.1 }}
                className="text-dark-emphasis"
              >
                He was instrumental in launching non-alcoholic wood polish, an
                innovative product in the industry. Together as a team, they
                brought one-of-its-kind innovation in India like packaging the
                products in HDPE bottles, which underlined the company’s strong
                presence in the industry.
              </motion.p>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col lg={8} className="text-center">
          <motion.h2
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.3 }}
            className="mb-3 fw-bold fs-2 title"
          >
            Our Mission
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.5 }}
            className="text-dark-emphasis"
          >
            To deliver innovative, high-quality products that exceed customer
            expectations and set new benchmarks in the industry.
          </motion.p>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUs;
